/*
 * KeeeX SAS Confidential
 * https://keeex.me
 * Copyright 2020 KeeeX All Rights Reserved.
 *
 * Author: WPS
 * -----
 */
import * as history from "history";

export default history.createBrowserHistory({ basename: "/" });
